import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// May 25, 2026 — Apply dark mode before React mounts so the user never
// sees a flash of the wrong palette. Reads localStorage synchronously;
// server-side preference syncs after auth resolves.
try {
  if (window.localStorage.getItem("mysilo_dark_mode") === "1") {
    document.documentElement.setAttribute("data-dark", "1");
  }
} catch { /* private browsing — no-op */ }

// Jun 2026 (Randy) — swallow the benign "ResizeObserver loop completed with
// undelivered notifications" error. It's harmless (fired by resize-driven UI
// like sliders/dialogs settling) but CRA's dev overlay turns it into a scary
// full-screen red "Uncaught runtime errors" box. Stop it before the overlay
// (and other listeners) ever see it.
const RO_NOISE = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
window.addEventListener("error", (e) => {
  if (e && e.message && RO_NOISE.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
